import React from 'react'
import PropTypes from 'prop-types'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'

import { ApplicationProvider } from '@contexts/ApplicationContext'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      refetchOnMount: false,
      useErrorBoundary: true
    },
  },
})

export const App = ({ children, config }) => {
  const appData = {
    permissions: config.permissions,
    featureConfig: config.featureConfig,
    featureToggles: config.featureToggles
  }

  const contextValue = {
    trackingDetails: constructTrackingDetails(config.userDetails, config.tenant),
    user: config.userDetails,
    theme: { ...config.colors },
    ...appData
  }

  return (
    <QueryClientProvider client={queryClient}>
      <ApplicationProvider value={contextValue}>
        {children}
      </ApplicationProvider>

      <ReactQueryDevtools position="bottom-right" initialIsOpen={false} />
    </QueryClientProvider>
  )
}

const constructTrackingDetails = (userDetails, tenant) => (
  {
    client_id: userDetails.client_id,
    client_email: userDetails.client_email,
    current_tenant: tenant.slug
  }
)

App.propTypes = {
  config: PropTypes.shape({
    userDetails: PropTypes.object.isRequired,
    tenant: PropTypes.object.isRequired,
    colors: PropTypes.object.isRequired,

    permissions: PropTypes.arrayOf(PropTypes.string).isRequired,
    featureConfig: PropTypes.object.isRequired,
    featureToggles: PropTypes.object.isRequired,
  }),
  showTalkToAWealthManager: PropTypes.bool,
}
